import firebase from 'firebase';

import * as collections from '../collectionTypes';
import { processQuerySnapshotItems, rejectIfNotFound } from './utils';

const db = firebase.firestore();
const collection = db.collection(collections.POSTS);

export function getPosts() {
  return collection
    .get()
    .then(processQuerySnapshotItems);
}

export function getPublicPosts() {
  return collection.where('publicKey', '>', '')
    .get()
    .then(processQuerySnapshotItems);
}

export function getPost(id) {
  return collection.doc(id)
    .get()
    .then(rejectIfNotFound);
}

export function getPostByAlias(alias) {
  return collection
    .where('alias', '==', alias)
    .limit(1)
    .get()
    .then((snapshot) => {
      if (snapshot.empty) {
        return Promise.reject('Empty snapshot');
      }

      const id = snapshot.docs[0].id;
      const data = snapshot.docs[0].data();
      return { ...data, id };
      // return { id, data };
    });
}

export function getPublicPostByAlias(alias, publicKey) {
  return collection
    .where('alias', '==', alias)
    .where('publicKey', '==', publicKey)
    .limit(1)
    .get()
    .then((snapshot) => {
      if (snapshot.empty) {
        return Promise.reject('Empty snapshot');
      }

      const id = snapshot.docs[0].id;
      const data = snapshot.docs[0].data();
      return { ...data, id };
      // return { id, data };
    });
}

export function createPost(post) {
  return collection.add(post)
    .then(doc => doc.id);
}

export function savePost(id, post) {
  return collection.doc(id).set(post);
}

export function removePost(id) {
  return collection.doc(id).delete();
}

export function generatePostId() {
  return collection.doc().id;
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/posts.js